import {inject} from '@angular/core'
import {ConfigService} from '../services/config.service'
import {ACCESS_TOKEN_KEY, LOCAL_STORAGE} from './constants'
import {filter, map, of} from 'rxjs'

export const appInitializer = () => {
  const storage = inject(LOCAL_STORAGE)
  const service = inject(ConfigService)
  return of(storage.getItem(ACCESS_TOKEN_KEY))
    .pipe(
      filter((at: string | null): at is string => {
        if (!at) {
          service.logout()
          return false
        }
        return true
      }),
      map(at => {
        service.login(JSON.parse(at))
      })
    )
}